import React, {
    useContext,
    useEffect,
} from "react"

import {
    useLocation,
} from "react-router-dom"

import {
    EMETLAssessmentTaskSubTaskPerformanceStep,
    EMETLPerformanceStepRating,
    PerformanceStepFlat, 
} from "../Model/EMETLAssessment.m"

import {
    Context, 
    EMETLContext,
} from "../Model/Contexts/AppContext"

import VM from "../ViewModel/AssessmentTaskSubTaskPerformanceSteps.vm"
import EMETLAssessmentDetailsPS from "./Components/EMETLAssessmentDetailsPS"
import { AssessmentTaskSubTaskPerformanceStep } from "../API"
import EMETLNavButton from "./Components/EMETLNavButton"

const AssessmentTaskSubTaskPerformanceSteps = () => {
    VM.ctx = useContext(Context)

    const {
        amplify,
        staticTasksAndPS: {
            value: t,
        },
        loading: {
            setMessage,
            update: setLoading,
        }
    } = VM.ctx as EMETLContext

    const [performanceSteps, setPerformanceSteps] = React.useState<AssessmentTaskSubTaskPerformanceStep[]>([])
    const location = useLocation()
    
    const {
        atID,
        taskNumber,
        assessmentTaskSubTaskID = null,
        subTaskID,
    } = location.state || {} 


    const load = async () => {
        if (!assessmentTaskSubTaskID)
            return
        
        setMessage("Loading performance steps")
        setLoading(true)
        const d = await VM.loadPerformanceStepsForAssessmentTaskSubTask(
            assessmentTaskSubTaskID,
        )
        setMessage("")
        setLoading(false)
        if (d)
            setPerformanceSteps(d)
        
        return d
    }

    const saveAssessmentTaskPerformanceStep = async (
        psID: number, 
        rating: EMETLPerformanceStepRating, 
        needs: string,
        atstid: number = null,
    ) => {
        if (!assessmentTaskSubTaskID && !atstid)
            return false

        const existingPSData = performanceSteps?.find(ps => ps.PSID === psID)
       
        let resp = null
        if (existingPSData) {
            setMessage("Updating performance step")
            setLoading(true)
            resp = await VM.updateAssessmentTaskSubTaskPerformanceStep({
                ...existingPSData,
                Rating: rating,
                SpecificNeeds: needs,
                ID: existingPSData.ID,
            })   
            setMessage("")
            setLoading(false)
        } else {
            setMessage("Creating performance step")
            setLoading(true)
            resp = await VM.createAssessmentTaskSubTaskPerformanceStep({
                ATSTID: assessmentTaskSubTaskID || atstid,
                PSID: psID,
                Rating: rating,
                SpecificNeeds: needs,
            })
            setMessage("")
            setLoading(false)
        }
        if (resp) {
            setPerformanceSteps(performanceSteps.map(ps => ps.PSID === psID ? resp : ps))
        } else {
            return false
        }

        return true
    }

    const saveAssessmentTaskSubTask = async () => {
        setMessage("Creating subtask to link performance step")
        setLoading(true)
        const resp = await VM.createAssessmentTaskSubTask({
            AssessmentTaskID: atID,
            SubTaskID: subTaskID,
            Rating: 0,
            SpecificNeeds: "",
        })
        setMessage("")
        setLoading(false)

        if (!resp)
            return null

        return resp.ID
    }

    const save = async (psID: number, rating: EMETLPerformanceStepRating, needs: string) => {
        let resp = false
        
        if (!assessmentTaskSubTaskID) {
            const newATSTID = await saveAssessmentTaskSubTask()
            if (!newATSTID) {
                return false
            }
            location.state = {
                ...location.state,
                assessmentTaskSubTaskID: newATSTID,
            }
            resp = await saveAssessmentTaskPerformanceStep(psID, rating, needs, newATSTID)
        } else
            resp = await saveAssessmentTaskPerformanceStep(psID, rating, needs)
            
        return resp
    }

    useEffect(() => {
        VM.db = amplify
        
        load()
    }, [amplify, t, assessmentTaskSubTaskID])

    return (
        <>
            {taskNumber && (
                <h3 className="m-4">
                    Performance Steps for {taskNumber}
                </h3>
            )}
            <EMETLNavButton
                onClick={() => history.back()}
                style={{
                    marginLeft: 25,
                }}
            >
                Go Back
            </EMETLNavButton>
            <div
                style={{
                    padding: "30px"
                }}
            >
                {!!Object.keys(t)?.length && taskNumber ? t[taskNumber]?.map(
                    (k: PerformanceStepFlat) => {
                        const existingPSData = performanceSteps?.find(ps => ps.PSID === k.PSID)

                        return (
                            <EMETLAssessmentDetailsPS
                                key={k.PSID}
                                step={{
                                    ...k,
                                    ...existingPSData,
                                }}
                                onSave={async (...rest) => {
                                    const r = await save(...rest)
                                    await load()
                                    
                                    return r
                                }}
                                needs={existingPSData?.SpecificNeeds}
                                rating={existingPSData?.Rating}
                            />
                        )
                    }
                ) : (
                    <h4 
                        className="text-secondary"
                    >
                        No performance steps are assigned to this subtask.
                    </h4>
                )}
            </div>
        </>
    )
}

export default AssessmentTaskSubTaskPerformanceSteps